import { Routes, Route } from "react-router-dom";

import { AuthProvider } from "./contexts/AuthContext";
import { TourProvider } from "./tour/TourContext";
import TourOverlay from "./tour/TourOverlay";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import LifecycleAnalysis from "./pages/LifecycleAnalysis";
import DevWorkload from "./pages/dev_workload";

function App() {
  return (
    <AuthProvider>
      <TourProvider>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />

        {/* Protected */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/lifecycle"
          element={
            <ProtectedRoute>
              <LifecycleAnalysis />
            </ProtectedRoute>
          }
        />
        <Route
          path="/developer-workload"
          element={
            <ProtectedRoute>
              <DevWorkload />
            </ProtectedRoute>
          }
        />
      </Routes>
      <TourOverlay />
      </TourProvider>
    </AuthProvider>
  );
}

export default App;
